import { useState, useCallback } from "react";
import type { SplitType } from "../types";

const KEY = "barnyard-default-split-type";

export function useSplitPreferences() {
  const [defaultSplitType, setType] = useState<SplitType>(() => {
    try {
      const saved = localStorage.getItem(KEY);
      if (saved === "equal" || saved === "personal" || saved === "joint") return saved;
    } catch {
      // Storage unavailable
    }
    return "joint";
  });

  const setDefaultSplitType = useCallback((type: SplitType) => {
    setType(type);
    try {
      localStorage.setItem(KEY, type);
    } catch {
      // Storage unavailable
    }
  }, []);

  return { defaultSplitType, setDefaultSplitType };
}
